import { helpers } from 'vuelidate/lib/validators'

import moment from 'moment';

export const password = helpers.regex('password', /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,}$/);

export const isAdult = (value) => moment().diff(moment(value), 'years') >= 18;

export const anyOptionRequired = (isValid) => (value) => isValid(value);

export const requiredStripeElement = (completed) => completed === true;